module.exports = "/_next/static/images/seed_shamir-914fc2e1a994aaab7d669fb12359f8fd.svg";